import { jsx, jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { Tag, Tooltip, Position, Intent } from "@blueprintjs/core";
export function CollaborationBadge({
  isConnected = false,
  collaborators = [],
  roomName = ""
}) {
  const count = collaborators.length;
  const tooltipContent = /* @__PURE__ */ jsxs("div", { style: { maxWidth: 220 }, children: [
    /* @__PURE__ */ jsx("div", { style: { fontWeight: 600, marginBottom: 4 }, children: isConnected ? "Real-time Collaboration Active" : "Disconnected (Offline Mode)" }),
    roomName && /* @__PURE__ */ jsxs("div", { style: { fontSize: 11, opacity: 0.8, marginBottom: 4 }, children: [
      "Room: ",
      roomName.length > 16 ? `${roomName.substring(0, 16)}...` : roomName
    ] }),
    count > 0 ? /* @__PURE__ */ jsxs("div", { children: [
      /* @__PURE__ */ jsx("div", { style: { fontSize: 11, marginBottom: 2 }, children: "Connected Collaborators:" }),
      /* @__PURE__ */ jsx("ul", { style: { margin: 0, paddingLeft: 16, fontSize: 12 }, children: collaborators.map((c, i) => /* @__PURE__ */ jsx("li", { style: { color: c.color || "inherit" }, children: c.name || `User ${i + 1}` }, c.id || i)) })
    ] }) : /* @__PURE__ */ jsx("div", { style: { fontSize: 11, fontStyle: "italic" }, children: "You are currently the only editor." })
  ] });
  return /* @__PURE__ */ jsx(Tooltip, { content: tooltipContent, position: Position.BOTTOM, children: /* @__PURE__ */ jsx(
    Tag,
    {
      minimal: true,
      intent: isConnected ? Intent.SUCCESS : Intent.WARNING,
      icon: isConnected ? "cloud" : "offline",
      style: {
        marginLeft: 8,
        cursor: "pointer",
        userSelect: "none"
      },
      "data-test": "collab-badge",
      children: isConnected ? `${count > 0 ? count : 1} live` : "offline"
    }
  ) });
}
export default CollaborationBadge;
